export default {
  departments: [],
  departmentsLoaded: false,
  paymentsAccepted: {},
};
